import React from 'react';
import { FormattedHTMLMessage, FormattedMessage, useIntl } from 'react-intl';
import { useTranslate } from '../hooks';
import { EMPTY_TRANSLATION } from '../constants';
export function Translate({ message, params, html = false, raw = false }) {
    const intl = useIntl();
    // react-intl doesn't support empty strings as translation value
    if (!message || intl.formatMessage({ id: message }, params) === EMPTY_TRANSLATION) {
        return null;
    }
    const Formatter = html ? FormattedHTMLMessage : FormattedMessage;
    const result = React.createElement(Formatter, { values: params, id: message });
    return raw ? result : React.createElement("span", null, result);
}
export function injectTranslate(WrappedComponent) {
    return (props) => {
        const translate = useTranslate();
        return React.createElement(WrappedComponent, { ...props, translate: translate });
    };
}
//# sourceMappingURL=Translate.js.map